/*
 * Copyright (c) Nexign, JSC, 2020-2021.
 */
/**
 * The common modal popup for show info message
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.1.2
 */


import { ReactNode } from 'react';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { LinkBlock } from '../../../components/common';
import { IRootReducer } from '../../../reducers/rootReducer';
import { makeSelectTranslationCommon } from '../../internationalization/intSelectors';
import { ICommonTranslation } from '../../internationalization/types';
import {
    ModalPopupContainerStyled,
    ModalPopupControlContainer,
    ModalPopupTextStyled,
    ModalPopupTitleStyled,
} from './styled/ModalStyled';

export interface IModalPopupConnectedProps {
    translation: ICommonTranslation;
}

export interface IModalPopup {
    children?: ReactNode;
    dataName: string;
    isEnableCloseButton?: boolean;
    okButtonKind?: 'medium' | 'mediumNormal';
    okButtonTitle?: string;
    onOkButtonClick?: () => void;
    onCloseModal: () => void;
    message?: string;
    title?: string;
    width?: string;
}

export type TModalPopup = IModalPopup & IModalPopupConnectedProps;

/**
 * @deprecated Use Modal component
 * @see Modal
 */
const ModalPopup = (props: TModalPopup) => {
    return (
        <ModalPopupContainerStyled
            data-component={'modal-popup'}
            data-name={props.dataName}
            width={props.width}
        >
            <ModalPopupTitleStyled data-name="modal-popup-title">
                {props.title ? props.title : props.translation.modal.attention}
            </ModalPopupTitleStyled>
            {
                props.message &&
                <ModalPopupTextStyled data-name="modal-popup-text">
                    {props.message}
                </ModalPopupTextStyled>
            }
            {props.children}
            <ModalPopupControlContainer>
                {
                    props.isEnableCloseButton &&
                    <LinkBlock data-name="close-button"
                               onClick={props.onCloseModal}
                    >
                        {props.translation.modal.close}
                    </LinkBlock>
                }
            </ModalPopupControlContainer>
        </ModalPopupContainerStyled>
    );
};

const mapStateToProps = createStructuredSelector<IRootReducer, IModalPopupConnectedProps>({
    translation: makeSelectTranslationCommon(),
});

export default connect(mapStateToProps)(ModalPopup);
